import plug from './img/plug_icon.svg'
import Rating from '@mui/material/Rating'
import customHeaders, { getSpace } from '../../../common/headers'
import StarIcon from '@mui/icons-material/Star'
import { SendMessage } from '../../SendMessage/SendMessage'
import { getFormatedDate } from '../../ChatReview/ChatReview'
import { useState, useEffect } from 'react'
import link_icon from './img/link_icon.svg'
import {
    ButtonBasic
} from "@lk-gtcom/ecomlab-components";
import { ChatMessage, UserMessage } from '../../ChatReview/ChatReview'
import { KonstantinMasterHttps, KonstantinMasterHttp, KonstantinFeedbackHttps, KonstantinFeedbackHttp } from '../../../fetchUrls'
import useGeneralStore from '../../../store/general'
import './ModalReview.scss'

const ModalReview = ({
    setIsModal,
    questData,
    setQuestData,
    pageValue,
    selectedStatus,
    setIsTableRequest,
    fetchCounter
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const current_page = pageValue == 'feedbacks' ? 'feedbacks' : 'questions'
    const current_req = pageValue == 'feedbacks' ? 'feedback' : 'question'

    const [chatMessages, setChatMessages] = useState([])
    const [author, setAuthor] = useState('')
    const [chatInfo, setChatInfo] = useState({})
    const [answerValue, setAnswerValue] = useState('')
    const { api_id,
        id,
        mp_id,
        rating,
        img,
        productName,
        offer_id,
        category_name,
        date,
        brand,
        review,
        product_name,
        product_valuation,
        created_at,
        primary_image,
        keyword_list,
        tag_list,
        status,
        link
    } = questData || {}

    const [loadAnswerAi, setLoadAnswerAi] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [answer, setAnswer] = useState('')
    const is_answer = pageValue === 'feedbacks'

    const fetchChat = () => {
        let url = `${KonstantinMasterHttps}/wb/${pageValue}/chat?api_id=${api_id}&mp_id=${mp_id}&${pageValue === 'feedbacks' ? 'feedback_id' : 'question_id'}=${id}`

        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(json => {
                const { api_id, chat_id, customer_name, messages, opened } = json
                if (messages) setChatMessages(messages)
                setAuthor(customer_name)
                setChatInfo({ api_id, id: chat_id, name: customer_name, opened })
                setAnswerValue('')
                setIsEdit(false)
            })
            .catch(err => {
                console.error(err)
            })
    }

    // Ответ на отзывы и на вопросы
    const fetchAnswer = () => {
        if (answerValue) {
            let url
            if (is_answer) {
                url = `${KonstantinFeedbackHttps}/${pageValue}/answer`
            } else {
                url = `https://apps1.ecomru.ru:4455/questions/answer`
            }

            const messageId = pageValue === 'feedbacks' ? { feedback_id: id } : { question_id: id }

            const body = JSON.stringify({
                mp_id,
                api_id,
                answer_text: answerValue,
                text: answerValue,
                ...messageId
            })

            fetch(url, { body, method: 'POST', headers })
                .then(res => {
                    setIsModal(false)
                    setTimeout(() => {
                        fetchCounter()
                        setIsTableRequest(prev => !prev)
                    }, 500)
                })
                .then(() => setIsModal(false))
                .catch(err => {
                    console.error(err)
                })
        }
    }

    // Отправить на модерацию
    const fetchAnswerModeration = () => {
        // setLoading(true)

        if (answerValue) {
            let url = `${KonstantinFeedbackHttps}/${current_page}/moderation/answer-text`

            const body = JSON.stringify({
                mp_id: mp_id,
                api_id: api_id,
                id: id,
                answer_text: answerValue
            })

            fetch(url, { body, method: 'PUT', headers })
                .then(res => {
                    setTimeout(() => {
                        fetchCounter()
                        setIsTableRequest(prev => !prev)
                    }, 500)
                })
                .catch(err => console.error(err))
                .finally(() => {
                    setIsModal(false)
                    setIsEdit(false)
                })
        }

    }

    // Вернуть в неотвеченные
    const fetchReturnAnswer = () => {
        // setLoading(true)

        if (answerValue) {
            let url = `https://apps1.ecomru.ru:4455/${current_page}/moderation/${current_req}`

            const body = JSON.stringify({
                mp_id: mp_id,
                api_id: api_id,
                id: id
            })

            fetch(url, { body, method: 'DELETE', headers })
                .then(res => {
                    setTimeout(() => {
                        fetchCounter()
                        setIsTableRequest(prev => !prev)
                    }, 500)
                    setIsModal(false)
                })
                .catch(err => console.error(err))
                .finally(() => setIsEdit(false))
        }

    }

    // вернуть в неотвеченные
    const fetchGetAnswerAi = () => {
        let url = `https://apps1.ecomru.ru:4456/reviews/ai-answers`
        setLoadAnswerAi(true)

        const body = JSON.stringify({
            mp_id: mp_id,
            api_id: api_id,
            feedback_id: id
        })

        fetch(url, { body, method: 'POST', headers })
            .then(res => res.json())
            .then((json) => {
                const { answer } = json
                if (answer) {
                    setAnswerValue(answer)
                    setAnswer(answer)
                }
                setTimeout(() => {
                    fetchCounter()
                    setIsTableRequest(prev => !prev)
                }, 500)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setLoadAnswerAi(false)
            })
    }

    // Изменить подтвержденный статус вопроса в таблице модерации.
    const fetchAnswerModerationConfirm = (status) => {
        let url = `${KonstantinFeedbackHttps}/${current_page}/moderation/confirmed-status`

        const body = JSON.stringify({
            mp_id: mp_id,
            api_id: api_id,
            id: id,
            confirmed: status
        })

        fetch(url, { body, method: 'PUT', headers })
            .then(res => {
                setTimeout(() => {
                    fetchCounter()
                    setIsTableRequest(prev => !prev)
                }, 500)
                setIsModal(false)
            })
            .catch(err => console.error(err))
            .finally(() => setIsEdit(false))

    }

    const messageTypeChecker = (message, path) => {
        const { message_id, user_type } = message
        return (
            user_type === 'seller' ?
                <ChatMessage
                    setAnswer={(e) => setAnswer(e)}
                    setIsEdit={(e) => setIsEdit(e)}
                    key={message_id}
                    {...message}
                    date={date} />
                :
                <UserMessage
                    author={author}
                    rating={rating}
                    key={message_id}
                    // currentImg={currentImg}
                    {...message}
                    path={path ? path : false} />
        )
    }

    useEffect(() => {
        fetchChat()
    }, [questData, selectedSpace])

    const curentNameBtn = () => {
        if (selectedStatus == 'Модерация') {
            return 'Подтвердить'
        } else if (selectedStatus == 'Ответ ожидает отправления') {
            return 'Вернуть на модерацию'
        } else {
            return 'Отправить'
        }
    }

    return (
        <div className='blackout' onClick={(e) => {
            let el = e.target
            if (el.classList.contains('blackout')) {
                setIsModal(false)
                setQuestData({})
            }
        }}>
            <div className='modal-review'>
                <div className='message'>
                    <div className='icon-container'>
                        <img src={img ? img : primary_image} onError={e => e.target.src = plug} />
                        <div className={status === 'Отвечен' ? 'answered' : 'not-answered'}>{status}</div>
                    </div>
                    <div className='info-content'>
                        <a className='modal-review__link' href={link || '#'} target='_blank'>
                            <h3 className='title'>{productName ? productName : product_name ? product_name : 'Нет названия'} </h3>
                            <img src={link_icon} alt="Ссылка" />
                        </a>

                        {keyword_list && <p className='text_grey'>Ключевые: {keyword_list?.slice(0, 3)?.join(', ')}</p>}
                        {tag_list && <p className='text_grey'>Теги: {tag_list?.slice(0, 3)?.join(', ')}</p>}
                    </div>
                    <div className='rating-and-date'>
                        {
                            (rating || product_valuation) &&
                            <div className='rating-color-box'>
                                {
                                    <Rating
                                        precision={1}
                                        defaultValue={rating ? rating : product_valuation ? product_valuation : ''}
                                        max={1}
                                        readOnly
                                        emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
                                        icon={<StarIcon style={{ fill: '#faaf00' }} />}
                                        size="large" />
                                }
                                <p className='text_rating'>{rating ? rating : product_valuation ? product_valuation : ''}</p>
                            </div>
                        }

                        <p className='text_date'>{getFormatedDate(date ? date : created_at, 'date')}
                            <span> {getFormatedDate(date ? date : created_at, 'time')}</span>
                        </p>
                    </div>
                </div>

                <div className='chat__content'>
                    {
                        chatMessages?.map((el, ind) => messageTypeChecker(el, rating ? rating : product_valuation ? product_valuation : '', author))
                    }
                </div>

                <SendMessage
                    frequentAnswers
                    btn={
                        <>
                            <ButtonBasic
                                grey
                                width='200px'
                                minWidth='200px'
                                text='Ответить с помощью ИИ'
                                onClick={(e) => {
                                    fetchGetAnswerAi()
                                }}
                                disabled={!chatInfo?.opened && !isEdit}
                            />

                            {selectedStatus == 'Модерация' ?
                                <>
                                    <ButtonBasic
                                        grey
                                        width='200px'
                                        minWidth='200px'
                                        text='Вернуть в неотвеченные'
                                        onClick={(e) => {
                                            fetchReturnAnswer()
                                        }}
                                    />

                                    <ButtonBasic
                                        greywidth='200px'
                                        minWidth='200px'
                                        width='auto'
                                        text='Cохранить на модерации'
                                        onClick={(e) => {
                                            //сохранить на модерации
                                            fetchAnswerModeration()
                                        }}
                                    />
                                </>
                                : null}
                        </>
                    }
                    actionBtnText={curentNameBtn()}
                    disabled={!chatInfo?.opened && selectedStatus != 'Модерация' && selectedStatus != 'Ответ ожидает отправления'}
                    value={answerValue}
                    loading={loadAnswerAi}
                    onChange={e => setAnswerValue(e)}
                    onSendAction={e => {
                        if (selectedStatus == 'Модерация') {
                            fetchAnswerModerationConfirm(true)
                        } else if (selectedStatus == 'Ответ ожидает отправления') {
                            fetchAnswerModerationConfirm(false)
                        } else {
                            fetchAnswer()
                        }
                    }}
                    isEdit={isEdit}
                    setIsEdit={(e) => setIsEdit(e)}
                    message={answer} />
            </div>
        </div>
    )
}

export { ModalReview }